module.exports = __webpack_public_path__ + "img/school-home.dc7c3948.jpg";